import Icon, { AvailableIcons } from "~/components/ui/Icon"
import Header from "~/components/ui/SectionHeader"

/**
 * @title label
 */
interface Benefit {
    /**
     * @title Ícone
     */
    icon: AvailableIcons
    /**
     * @title Título
     */
    label: string
    /**
     * @title Descrição
     */
    description: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string
    /**
     * @title Descrição
     */
    description?: string
    /**
     * @title Benefícios
     */
    benefits?: Benefit[]
    layout?: {
        /**
         * @title Variação
         */
        variation?: 'Simple' | 'With border' | 'Color reverse'
        /**
         * @title Alinhamento do cabeçalho
         */
        headerAlignment?: 'center' | 'left'
    }
}

export default function Benefits(props: Props) {
    const {
        title = '',
        description = '',
        benefits = [
            {
                icon: 'Truck',
                label: 'Entrega em todo Brasil',
                description: 'Consulte o prazo no fechamento da compra.',
            },
            {
                icon: 'Discount',
                label: '15% na primeira compra',
                description: 'Aplicado direto na sacola de compras.',
            },
            {
                icon: 'ArrowsPointingOut',
                label: 'Devolução grátis',
                description: 'Veja as condições para devolver seu produto.',
            },
        ],
        layout,
    } = props

    const listOfBenefits = benefits.map((benefit, index) => {
        const showDivider = index < benefits.length - 1
        const reverse = layout?.variation === 'Color reverse'
        const benefitLayout = !layout?.variation || layout?.variation === 'Simple'
            ? 'tiled'
            : 'piledup'

        return (
            <div
                className={`${
                    reverse ? 'bg-primary text-primary-content p-4 lg:px-8 lg:py-4' : ''
                } flex gap-4 ${
                    benefitLayout == 'piledup' ? 'flex-col items-center text-center' : ''
                } ${
                    showDivider && benefitLayout !== 'piledup'
                        ? 'border-b border-neutral-300'
                        : ''
                } ${showDivider ? 'pb-4 lg:pr-8 lg:border-r lg:border-b-0' : ''} ${
                    showDivider && !reverse ? 'lg:pb-0' : ''
                }`}
            >
                <div className='flex-none'>
                    <Icon
                        id={benefit.icon}
                        className={reverse ? 'text-base-100' : 'text-primary'}
                        width={36}
                        height={36}
                        strokeWidth={0.01}
                        fill='currentColor'
                    />
                </div>
                <div className='flex-auto flex flex-col gap-1 lg:gap-2'>
                    <div
                        className={`text-base lg:text-xl leading-7 ${
                            reverse ? 'text-base-100' : 'text-base-content'
                        }`}
                    >
                        {benefit.label}
                    </div>
                    <p
                        className={`text-sm leading-5 ${reverse ? 'text-base-100' : 'text-neutral'} ${
                            benefitLayout == 'piledup' ? 'hidden lg:block' : ''
                        }`}
                    >
                        {benefit.description}
                    </p>
                </div>
            </div>
        )
    })

    return (
        <>
            {!layout?.variation || layout?.variation === 'Simple'
                ? (
                    <div className='w-full container px-4 py-8 flex flex-col gap-8 lg:gap-10 lg:py-10 lg:px-0'>
                        <Header
                            title={title}
                            description={description}
                            alignment={layout?.headerAlignment || 'center'}
                        />
                        <div className='w-full flex justify-center'>
                            <div className='flex flex-col gap-4 lg:gap-8 w-full lg:grid grid-flow-col auto-cols-fr'>
                                {listOfBenefits}
                            </div>
                        </div>
                    </div>
                )
                : (
                    ''
                )}
            {layout?.variation === 'With border' && (
                <div className='w-full container flex flex-col px-4 py-8 gap-8 lg:gap-10 lg:py-10 lg:px-0'>
                    <Header
                        title={title}
                        description={description}
                        alignment={layout?.headerAlignment || 'center'}
                    />
                    <div className='w-full flex justify-center'>
                        <div className='grid grid-cols-2 gap-4 w-full py-6 px-4 border border-base-300 lg:gap-8 lg:grid-flow-col lg:auto-cols-fr lg:p-10'>
                            {listOfBenefits}
                        </div>
                    </div>
                </div>
            )}
            {layout?.variation === 'Color reverse' && (
                <div className='w-full container flex flex-col px-4 py-8 gap-8 lg:gap-10 lg:py-10 lg:px-0'>
                    <Header
                        title={title}
                        description={description}
                        alignment={layout?.headerAlignment || 'center'}
                    />
                    <div className='w-full flex justify-center'>
                        <div className='grid grid-cols-2 gap-4 w-full lg:gap-8 lg:grid-flow-col lg:auto-cols-fr'>
                            {listOfBenefits}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export { default as LoadingFallback } from "~/components/LoadingFallback"
